import { apiClient } from '../../app/api/client';
import type {
  BundleImportPreview,
  ConflictResolution,
  ExportPreview,
  ExportRunRecord,
  ExportSelection,
  ImportedProjectSnapshot,
} from './types';

export interface ExportApi {
  commitBundle(token: string, resolution: ConflictResolution): Promise<ImportedProjectSnapshot>;
  create(selection: ExportSelection): Promise<ExportRunRecord>;
  get(runId: string): Promise<ExportRunRecord>;
  preview(projectId: string): Promise<ExportPreview>;
  previewBundle(file: File): Promise<BundleImportPreview>;
}

async function previewBundle(file: File): Promise<BundleImportPreview> {
  return await apiClient.post('/project-bundles/import-preview', {
    body: file,
    headers: {
      'Content-Type': 'application/zip',
      'X-Flowwiz-Filename': file.name,
    },
  });
}

export const exportApi: ExportApi = {
  commitBundle: (token, resolution) =>
    apiClient.post('/project-bundles/import-commit', {
      json: { preview_token: token, resolution },
    }),
  create: (selection) => apiClient.post('/exports/runs', { json: selection }),
  get: (runId) => apiClient.get(`/exports/runs/${runId}`),
  preview: (projectId) => apiClient.get(`/exports/projects/${projectId}/preview`),
  previewBundle,
};
